export const USER = "user"
export const USER_ID = "userId"
export const VERIFY_EMAIL = "verifyEmail"
export const PREVIEW_THEME = "previewTheme"